import React, { useState, useCallback } from 'react';
import { Title } from '@landing/ui';
import { Container } from 'components/UI';
import DirectionCard from './DirectionCard';
import DirectionsModal from './DirectionsModal';
import { useStateModal } from 'utils/hooks';
import * as styles from './Directions.module.scss';

export default function Directions({ title, items }) {
  const [state, setState] = useState();
  const { modalState, showModal, hideModal } = useStateModal();

  const callModal = useCallback(data => {
    setState(data);
    showModal();
  }, []);

  return (
    <Container id="requirements" background="lightGray">
      <div className={styles.wrapper}>
        <Title tag="h2">{title}</Title>
        <div className={styles.layout}>
          {items.map(item => (
            <DirectionCard
              key={item.title}
              title={item.title}
              handleClick={() => callModal(item.data)}
              {...item}
            />
          ))}
        </div>
      </div>
      <DirectionsModal isOpen={modalState.isOpen} closeModalCallback={hideModal} {...state} />
    </Container>
  );
}
